import { render } from "./ChallengeReportingForm.vue?vue&type=template&id=5d564f6a"
import script from "./ChallengeReportingForm.vue?vue&type=script&lang=js"
export * from "./ChallengeReportingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__